module.exports = __webpack_public_path__ + "static/media/applogo.5d112eb7.png";